var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3183",
    "data-name": "Rectangle 3183",
    width: 24,
    height: 24,
    transform: "translate(46 273)",
    fill: "none",
    stroke: "#232323",
    strokeWidth: 1.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5897",
    "data-name": "Mask Group 5897",
    transform: "translate(-46 -273)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Storage_Box",
    transform: "translate(28.857 240.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8876",
    "data-name": "Path 8876",
    d: "M36.736,40.649H21.55A1.55,1.55,0,0,1,20,39.1V37.55A1.55,1.55,0,0,1,21.55,36H36.736a1.55,1.55,0,0,1,1.55,1.55V39.1A1.55,1.55,0,0,1,36.736,40.649Z",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8877",
    "data-name": "Path 8877",
    d: "M60,236v7.748a1.55,1.55,0,0,0,1.55,1.55H73.636a1.55,1.55,0,0,0,1.55-1.55V236",
    transform: "translate(-38.45 -192.252)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8878",
    "data-name": "Path 8878",
    d: "M180.649,239.1h-3.1a1.55,1.55,0,0,1,0-3.1h3.1a1.55,1.55,0,0,1,0,3.1Z",
    transform: "translate(-149.957 -192.252)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistoryIcon);
export default __webpack_public_path__ + "static/media/OrderHistoryIcon.619b32fd1edc7d09641d4ca340e2515d.svg";
export { ForwardRef as ReactComponent };